import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  min-height: 100vh;
  z-index: 1;

  background-color: #000;
  background: #000;

  @page {
    background-color: #000;
    background: #000;
    size: 29.7cm 21cm;
    margin: 0;
    padding: 0;
  }

  @media print {
    @page {
      size: landscape;
    }

    .certificate-page {
      page-break-after: always;
    }

    .certificate-page:last-child {
      page-break-after: auto;
    }
  }

  .certificate {
    width: 29.7cm;
    height: 21cm;
    background-color: #fff;

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .certificate > img {
    width: 29.7cm;
    height: 21cm;
  }

  .certificate-details {
    background: #fff;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .details-content {
    width: 100%;
    height: 100%;
    padding: 60px 80px;
    overflow: hidden;
    font-family: "NunitoSans-Regular";
    color: #3c3535;
  }

  .details-content h1 {
    font-family: "NunitoSans-Bold";
    font-size: 22px;
    color: #861811;
    margin: 0 0 8px;
    text-transform: uppercase;
  }

  .details-content h2 {
    font-family: "NunitoSans-Bold";
    font-size: 20px;
    margin: 0 0 24px;
  }

  .details-section {
    margin-bottom: 20px;
  }

  .details-section h3 {
    font-family: "NunitoSans-Bold";
    font-size: 16px;
    color: #861811;
    margin: 0 0 8px;
  }

  .details-text {
    font-size: 14px;
    line-height: 22px;
    margin: 0;
    text-align: justify;
  }

  .details-list {
    margin: 0 0 8px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 22px;
  }

  .speakers-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .speaker-item {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
  }

  .speaker-item:last-child {
    border-bottom: 0;
  }

  .speaker-photo {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .speaker-info strong {
    display: block;
    font-family: "NunitoSans-Bold";
    font-size: 15px;
    margin-bottom: 4px;
  }

  .speaker-info p,
  .speaker-curriculum {
    font-size: 13px;
    line-height: 20px;
    margin: 0;
    text-align: justify;
  }

  .details-validation {
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #ddd;
  }

  .content {
    position: absolute;
    padding: 100px;
    font-size: 16px;
    line-height: 31px;
    padding-left: 250px;
    text-align: justify;

    font-family: "NunitoSans-Regular";
  }

  .content strong {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
    font-family: "NunitoSans-Bold";
  }

  .validation {
    position: absolute;
    right: 40px;
    bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.85);
    padding: 8px;
    border-radius: 4px;
  }

  .validation img {
    width: 90px;
    height: 90px;
  }

  .validation span {
    font-family: "NunitoSans-Regular";
    font-size: 10px;
    color: #3c3535;
    text-align: center;
    max-width: 110px;
    word-break: break-all;
  }
`;
export const RatingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  @media print {
    display: none;
  }
`;

export const RatingBox = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 30px;
  max-width: 500px;
  width: 100%;

  @media print {
    display: none;
  }
`;

export const RatingTitle = styled.h2`
  font-family: "NunitoSans-Bold";
  font-size: 24px;
  color: #3c3535;
  margin-bottom: 20px;
  text-align: center;
`;

export const RatingStars = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

export const StarButton = styled.button`
  background: none;
  border: none;
  font-size: 40px;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  color: ${props => (props.selected ? "#FFD700" : "#E6E6E6")};
  transition: all 0.2s;
  padding: 0;
  line-height: 1;

  &:hover {
    ${props => (!props.disabled ? "transform: scale(1.1);" : "")}
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const RatingComment = styled.div`
  margin-top: 20px;
`;

export const RatingTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  font-family: "NunitoSans-Regular";
  font-size: 14px;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: #861811;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const RatingButton = styled.button`
  background-color: #861811;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 12px 24px;
  font-family: "NunitoSans-Regular";
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;

  &:hover:not(:disabled) {
    background-color: #d9473d;
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RatingMessage = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4caf50;
  color: #ffffff;
  padding: 15px 30px;
  border-radius: 5px;
  font-family: "NunitoSans-SemiBold";
  font-size: 16px;
  z-index: 1001;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);

  @media print {
    display: none;
  }
`;
